<template>
  <div class="text-block">
    <h3 class="title is-size-4">{{ block.headline }}</h3>
    <div v-html="compiledMarkdown"></div>
  </div>
</template>

<script>
export default {
  name: 'TemplateTextBlock',
  props: {
    block: Object,
  },
  computed: {
    compiledMarkdown: function() {
      if (!this.block || !this.block.content) return ''
      // eslint-disable-next-line
      return marked(this.block.content, {sanitize: true})
    },
  },
}
</script>

<style scoped lang="scss">
// .text-block:not(:last-child){
.text-block {
  margin-bottom: 1.5em;
}
</style>
